import AppUtils from "./AppUtils";
import CookieUtils from "./CookieUtils";
import Upload from "./Upload";

const AppUtilsInstance = new AppUtils();

export { AppUtils, CookieUtils, AppUtilsInstance, Upload };
